/**
 * seasons.tsx
 * 
 * @copyright jnakaso.com
 * 
 * Seasons page will contain
 * <li>GOY</li>
 * <li>Qualifiers</li>
 * <li>Match Play Results</li>
 * <li>Tournament Results</li>
 * 
 */

import { useContext, useEffect, useState } from "react";
import { GoyCard } from "src/components/cards/goyCard";
import { SettingsContext } from "src/components/contexts";
import { storageService } from "src/services/storageService";


export function Goy() {
    const { settings } = useContext(SettingsContext);
    const [season, setSeason] = useState<number>(new Date().getFullYear());
    const [standings, setStandings] = useState<any>([]);

    useEffect(() => {
        if (settings) {
            setSeason(Number(settings.season))
        }
    }, [settings]);

    useEffect(() => {
        if (season) {
            storageService.getSeasonFile(season, 'goy.json')
                .then(t => setStandings(JSON.parse(t)));
        }
    }, [season]);

    return <GoyCard season={season} standings={standings} />

}
